let elements = {
  //pick: 3,
  blockCheck: true,
  permanent: true,
  mainImage: {
    imagePath: 'games/page055_game0/img/bcg.webp',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  audio: {
    negative: 'games/page055_game0/audio/false.mp3',
    // positive: 'games/page055_game0/audio/7_mole.mp3',
    click: 'games/page055_game0/audio/click.mp3',
    icon: {
      on: 'games/page055_game0/img/audioOn.png',
      off: 'games/page055_game0/img/audioOff.png',
    },
  },
  itemsConfig: {
    width: 60,
    height: 60,
    background: 'transparent',
  },
  correctItemsConfig: {
    width: 273,
    height: 369,
  },
  layoutItems: [
    {
      pos: {
        x: 0,
        y: 0,
      },
    },
    {
      pos: {
        x: 0,
        y: 0,
      },
    },
    {
      pos: {
        x: 0,
        y: 0,
      },
    },
    {
      pos: {
        x: 0,
        y: 0,
      },
    },
  ],
  layoutCorrectItems: [
    {
      pos: {
        x: 54,
        y: 51,
      },
    },
    {
      pos: {
        x: 53,
        y: 461,
      },
    },
    {
      pos: {
        x: 414,
        y: 461,
      },
    },
    {
      pos: {
        x: 1233,
        y: 461,
      },
    },
    {
      pos: {
        x: 1593,
        y: 461,
      },
    },
    {
      pos: {
        x: 1594,
        y: 51,
      },
    },
  ],
  shuffle: false,
  shuffleCorrect: false,
  shuffleGroups: true,
  shuffleInsideItems: false,
  pick: 0,
  falseStatus: true,
  groups: [
    {
      items: [
        {
          audioSrc: 'games/page055_game0/audio/86_Easter_bunny.mp3',
          correct: {
            audioId: 'a01',
            image: {
              src: 'games/page055_game0/img/rabbit.webp',
            },
            width: 273,
            height: 369,
            correctItems: {
              images: [
                {
                  src: 'games/page055_game0/img/rabbitok.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 273,
                  height: 369,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            audioId: 'a02',
            image: {
              src: 'games/page055_game0/img/szynka.webp',
            },
            width: 273,
            height: 369,
            incorrectItems: {
              images: [
                {
                  src: 'games/page055_game0/img/szynkawr.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 273,
                  height: 369,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            audioId: 'a03',
            image: {
              src: 'games/page055_game0/img/gwiazda.webp',
            },
            width: 273,
            height: 369,
            incorrectItems: {
              images: [
                {
                  src: 'games/page055_game0/img/gwiazdawr.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 273,
                  height: 369,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    {
      items: [
        {
          audioSrc: 'games/page055_game0/audio/84_decorate.mp3',
          correct: {
            audioId: 'a04',
            image: {
              src: 'games/page055_game0/img/jajo.webp',
            },
            width: 273,
            height: 369,
            correctItems: {
              images: [
                {
                  src: 'games/page055_game0/img/jajook.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 273,
                  height: 369,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    {
      items: [
        {
          audioSrc: 'games/page055_game0/audio/85_chocolate.mp3',
          correct: {
            audioId: 'a05',
            image: {
              src: 'games/page055_game0/img/czekolada.webp',
            },
            width: 273,
            height: 369,
            correctItems: {
              images: [
                {
                  src: 'games/page055_game0/img/czekoladaok.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 273,
                  height: 369,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    {
      items: [
        {
          audioSrc: 'games/page055_game0/audio/83_Easter_eggs.mp3',
          correct: {
            audioId: 'a06',
            image: {
              src: 'games/page055_game0/img/pisanki.webp',
            },
            width: 273,
            height: 369,
            correctItems: {
              images: [
                {
                  src: 'games/page055_game0/img/pisankiok.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 273,
                  height: 369,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
  ],
  // staticMaskConfig: [
  //   {
  //     id: 'm1',
  //     pos: {
  //       x: 49,
  //       y: 208 + 11 - 168,
  //     },
  //     unit: 'px',
  //     click: { src: 'games/page055_game0/audio/click.mp3' },
  //     src: 'games/page055_game0/img/folia.png',
  //   },
  //   {
  //     id: 'm2',
  //     pos: {
  //       x: 49,
  //       y: 618 + 11 - 168,
  //     },
  //     unit: 'px',
  //     click: { src: 'games/page055_game0/audio/click.mp3' },
  //     src: 'games/page055_game0/img/folia.png',
  //   },
  //   {
  //     id: 'm3',
  //     pos: {
  //       x: 410,
  //       y: 618 + 11 - 168,
  //     },
  //     unit: 'px',
  //     click: { src: 'games/page055_game0/audio/click.mp3' },
  //     src: 'games/page055_game0/img/folia.png',
  //   },
  //   {
  //     id: 'm4',
  //     pos: {
  //       x: 1229,
  //       y: 618 + 11 - 168,
  //     },
  //     unit: 'px',
  //     click: { src: 'games/page055_game0/audio/click.mp3' },
  //     src: 'games/page055_game0/img/folia.png',
  //   },
  //   {
  //     id: 'm5',
  //     pos: {
  //       x: 1589,
  //       y: 618 + 11 - 168,
  //     },
  //     unit: 'px',
  //     click: { src: 'games/page055_game0/audio/click.mp3' },
  //     src: 'games/page055_game0/img/folia.png',
  //   },
  //   {
  //     id: 'm6',
  //     pos: {
  //       x: 1589,
  //       y: 208 + 11 - 168,
  //     },
  //     unit: 'px',
  //     click: { src: 'games/page055_game0/audio/click.mp3' },
  //     src: 'games/page055_game0/img/folia.png',
  //   },
  // ],
  mbAudioItemData: [
    {
      maskConfig: {
        click: { src: 'games/page055_game0/audio/click.mp3' },
        src: 'games/page055_game0/img/folia.png',
        cssStyle: {
          'margin-left': '-24px',
          'margin-top': '-242px',
        },
      },
      id: 'a01',
      src: 'games/page055_game0/audio/86_Easter_bunny.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page055_game0/img/audioOn.png', iconOff: 'games/page055_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 300 + 17,
        x: -4,
      },
      width: '48px',
      height: '48px',
      unit: 'px',
    },
    {
      maskConfig: {
        click: { src: 'games/page055_game0/audio/click.mp3' },
        src: 'games/page055_game0/img/folia.png',
        cssStyle: {
          'margin-left': '-24px',
          'margin-top': '-242px',
        },
      },
      id: 'a02',
      src: 'games/page055_game0/audio/82_ham.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page055_game0/img/audioOn.png', iconOff: 'games/page055_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 300 + 17,
        x: -4,
      },
      width: '48px',
      height: '48px',
      unit: 'px',
    },
    {
      maskConfig: {
        click: { src: 'games/page055_game0/audio/click.mp3' },
        src: 'games/page055_game0/img/folia.png',
        cssStyle: {
          'margin-left': '-24px',
          'margin-top': '-242px',
        },
      },
      id: 'a03',
      src: 'games/page055_game0/audio/74_stars.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page055_game0/img/audioOn.png', iconOff: 'games/page055_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 300 + 17,
        x: -4,
      },
      width: '48px',
      height: '48px',
      unit: 'px',
    },
    {
      maskConfig: {
        click: { src: 'games/page055_game0/audio/click.mp3' },
        src: 'games/page055_game0/img/folia.png',
        cssStyle: {
          'margin-left': '-24px',
          'margin-top': '-242px',
        },
      },
      id: 'a04',
      src: 'games/page055_game0/audio/84_decorate.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page055_game0/img/audioOn.png', iconOff: 'games/page055_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 300 + 17,
        x: -4,
      },
      width: '48px',
      height: '48px',
      unit: 'px',
    },
    {
      maskConfig: {
        click: { src: 'games/page055_game0/audio/click.mp3' },
        src: 'games/page055_game0/img/folia.png',
        cssStyle: {
          'margin-left': '-24px',
          'margin-top': '-242px',
        },
      },
      id: 'a05',
      src: 'games/page055_game0/audio/85_chocolate.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page055_game0/img/audioOn.png', iconOff: 'games/page055_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 300 + 17,
        x: -4,
      },
      width: '48px',
      height: '48px',
      unit: 'px',
    },
    {
      maskConfig: {
        click: { src: 'games/page055_game0/audio/click.mp3' },
        src: 'games/page055_game0/img/folia.png',
        cssStyle: {
          'margin-left': '-24px',
          'margin-top': '-242px',
        },
      },
      id: 'a06',
      src: 'games/page055_game0/audio/83_Easter_eggs.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page055_game0/img/audioOn.png', iconOff: 'games/page055_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 300 + 17,
        x: -4,
      },
      width: '48px',
      height: '48px',
      unit: 'px',
    },
  ],
};

export default elements;
